import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";

import {View} from "@khanacademy/wonder-blocks-core";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {mediaQueries} from "@repo/shared-styles";

import {InfoText} from "#auth/new_components/choose-role-page.tsx";
import {
    RolePicker,
    useBypassRolePicker,
} from "#auth/new_components/role-picker.tsx";

import {NewRegistrationHeroFigure} from "./hero-figures.tsx";
import {LohpTwoColumns} from "./lohp-two-column.tsx";

const LohpChooseRole = () => {
    const learnerNextUrl = "/lohp/learner";
    const teacherNextUrl = "/lohp/teacher";
    const parentNextUrl = "/lohp/parent";

    const Redirect = useBypassRolePicker(teacherNextUrl, parentNextUrl);
    if (Redirect) {
        return Redirect;
    }

    return (
        <View style={styles.heroModule}>
            <LohpTwoColumns
                leftComponent={<NewRegistrationHeroFigure />}
                rightComponent={
                    <RolePicker
                        title={t`Start learning today by signing up!`}
                        infoText={<InfoText />}
                        learnerNextUrl={learnerNextUrl}
                        teacherNextUrl={teacherNextUrl}
                        parentNextUrl={parentNextUrl}
                    />
                }
                columnTemplate="60% 40%"
            />
        </View>
    );
};

const styles = StyleSheet.create({
    heroModule: {
        [mediaQueries.lgOrLarger]: {
            paddingTop: spacing.xxxLarge_64,
        },
        alignItems: "center",
        maxWidth: 1200,
        margin: "0 auto",
    },
});

export default LohpChooseRole;
